import classnames from 'classnames'
import React from 'react'

import { OptionContainer } from '../option-container/option-container'
import { OptionProp } from '../OptionSelector.constant'

import styles from './colorOption.module.scss'

type ColorOptionProps = {
  value: string
  displayName?: string
  hexCode?: string
  disabled?: boolean
  onChange?: (value: string) => void
} & Pick<OptionProp, 'isSelected' | 'addborder' | 'selectionSetId' | 'className'>
export const ColorOption = ({
  value,
  displayName,
  hexCode,
  isSelected,
  addborder,
  disabled,
  selectionSetId,
  className,
  onChange,
}: ColorOptionProps) => {
  const borderClass = styles.colorDotBorder
  return (
    <OptionContainer
      value={value}
      displayName={displayName}
      isSelected={isSelected}
      selectionSetId={selectionSetId}
      srOnly
      labelClassName={classnames(styles.label, className)}
      inputClassName={styles.input}
      disabled={disabled}
      onChange={onChange}
    >
      <span
        className={classnames(styles.colorDot, {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          [borderClass!]: addborder,
        })}
        style={{ backgroundColor: hexCode }}
      />
    </OptionContainer>
  )
}

const ColorOptionWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return (
    <ColorOption
      value={optionValue.value}
      displayName={optionValue.displayName}
      hexCode={optionValue.hexCode}
      {...props}
    />
  )
}

export default ColorOptionWithOptionValue
